// constants for graph usage
export const state = {
  dragLink: {},
};

const lerp = (norm, min, max) => {
  return (max - min) * norm + min;
};

const GRID = 200;
export const CONSTANTS = {
  node_height: GRID,
  node_width: GRID * 3,
  grid_size: GRID,
  node_padding: GRID / 6,
  node_inactive_color: '#B2B2B2',
  node_selected_stroke_color: '#002B5C',
  node_selected_fill_color: '#EBF3FF',
  title_font_size: GRID * 0.17,
  type_font_size: GRID * 0.1,
  indicator_font_size: GRID * 0.15,
  delta: 10,
  radius: GRID * 0.08,
  corner_radius: 55,
  corner_code_radius: 72,
  corner_output_radius: 12,
  string_max_length: 18,
  capital_string_max_length: 16,
  indicator_width: 55,
};

// TODO: figure out the MAGIC NUMBERS mess (most likely will be a graph rewrite)
export const VISIBLE_NODE_WIDTH =
  CONSTANTS.node_width - CONSTANTS.node_padding * 4.2;
export const VISIBLE_NODE_HEIGHT = VISIBLE_NODE_WIDTH * 0.3;
export const VISIBLE_PADDING_Y =
  (CONSTANTS.node_height - VISIBLE_NODE_HEIGHT) / 2;
export const VISIBLE_NODE_X =
  (CONSTANTS.node_width - VISIBLE_NODE_WIDTH) / 2 - CONSTANTS.delta;
export const VISIBLE_NODE_Y = VISIBLE_PADDING_Y - CONSTANTS.delta;
export const NODE_TYPE_Y =
  lerp(0.225, 0, VISIBLE_NODE_HEIGHT) + VISIBLE_PADDING_Y;
export const NODE_TITLE_Y = CONSTANTS.node_height / 2;
export const NODE_CIRCLE_INDICATOR_Y =
  lerp(0.225, 0, VISIBLE_NODE_HEIGHT) - CONSTANTS.delta - 7;
export const NODE_CIRCLE_INDICATOR_LEFT_X =
  CONSTANTS.node_padding + VISIBLE_NODE_X;
export const NODE_CIRCLE_INDICATOR_RIGHT_X =
  VISIBLE_NODE_X + VISIBLE_NODE_WIDTH - 32;

export const SVG = {
  AB: `<svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        id="ab-test-icon"
        class="abIcon"
        >
          <rect width="80" height="80" rx="4" fill="#FFD37B" />
          <path
          d="M56.896 51.4375L46.2501 33.1875V23.3334H48.3335C48.886 23.3334 49.4159 23.1139 49.8066 22.7232C50.1973 22.3325 50.4168 21.8026 50.4168 21.25C50.4168 20.6975 50.1973 20.1676 49.8066 19.7769C49.4159 19.3862 48.886 19.1667 48.3335 19.1667H31.6668C31.1143 19.1667 30.5844 19.3862 30.1937 19.7769C29.803 20.1676 29.5835 20.6975 29.5835 21.25C29.5835 21.8026 29.803 22.3325 30.1937 22.7232C30.5844 23.1139 31.1143 23.3334 31.6668 23.3334H33.7501V33.1875L23.1043 51.4375C22.5513 52.3869 22.2583 53.4654 22.2549 54.5641C22.2515 55.6628 22.5379 56.7431 23.085 57.6959C23.6322 58.6487 24.4209 59.4404 25.3716 59.9912C26.3223 60.542 27.4014 60.8325 28.5001 60.8334H51.4168C52.5155 60.8325 53.5947 60.542 54.5454 59.9912C55.496 59.4404 56.2847 58.6487 56.8319 57.6959C57.3791 56.7431 57.6654 55.6628 57.662 54.5641C57.6586 53.4654 57.3657 52.3869 56.8126 51.4375H56.896ZM37.6251 34.7709C37.8089 34.4615 37.9094 34.1098 37.9168 33.75V23.3334H42.0835V33.75C42.0873 34.1169 42.1879 34.4762 42.3751 34.7917L44.1668 37.9167H35.8335L37.6251 34.7709ZM53.2918 55.6042C53.11 55.9191 52.849 56.1809 52.5347 56.3636C52.2204 56.5464 51.8637 56.6437 51.5001 56.6459H28.5835C28.2199 56.6437 27.8632 56.5464 27.5489 56.3636C27.2346 56.1809 26.9736 55.9191 26.7918 55.6042C26.609 55.2875 26.5127 54.9282 26.5127 54.5625C26.5127 54.1968 26.609 53.8376 26.7918 53.5209L33.396 42.0834H46.6251L53.2918 53.5417C53.4747 53.8584 53.5709 54.2177 53.5709 54.5834C53.5709 54.9491 53.4747 55.3083 53.2918 55.625V55.6042ZM35.8335 46.25C35.4214 46.25 35.0186 46.3722 34.676 46.6011C34.3334 46.83 34.0664 47.1554 33.9087 47.5361C33.751 47.9168 33.7098 48.3357 33.7902 48.7398C33.8706 49.1439 34.069 49.5151 34.3603 49.8065C34.6517 50.0979 35.0229 50.2963 35.427 50.3767C35.8312 50.457 36.2501 50.4158 36.6307 50.2581C37.0114 50.1004 37.3368 49.8334 37.5657 49.4908C37.7946 49.1482 37.9168 48.7454 37.9168 48.3334C37.9168 47.7808 37.6973 47.2509 37.3066 46.8602C36.9159 46.4695 36.386 46.25 35.8335 46.25ZM44.1668 48.3334C43.7548 48.3334 43.352 48.4555 43.0094 48.6845C42.6668 48.9134 42.3997 49.2388 42.2421 49.6194C42.0844 50.0001 42.0431 50.419 42.1235 50.8231C42.2039 51.2273 42.4023 51.5985 42.6937 51.8898C42.985 52.1812 43.3562 52.3796 43.7604 52.46C44.1645 52.5404 44.5834 52.4991 44.9641 52.3414C45.3447 52.1838 45.6701 51.9167 45.899 51.5741C46.128 51.2315 46.2501 50.8287 46.2501 50.4167C46.2501 49.8642 46.0306 49.3342 45.6399 48.9435C45.2492 48.5528 44.7193 48.3334 44.1668 48.3334Z"
          fill="#1B1B1B"
          />
      </svg>`,
};
